import React from 'react';
import { InfoModal, InfoModalProps } from '../../../../theme/components';
import ReportDetail, { ReportDetailProps } from './ReportDetail';
import { Report } from '../../../../redux/reports/api/Report.model';

interface ReportDetailModalProps extends InfoModalProps {
  report?: Report;
  groupId?: string;
}
function ReportDetailModal(props: ReportDetailModalProps) {
  const { report, groupId } = props;
  return (
    <InfoModal maxWidth="md" fullWidth {...props}>
      {report && <ReportDetail report={report} groupId={groupId} />}
    </InfoModal>
  );
}

export default ReportDetailModal;
